import { AppState, Platform } from 'react-native'

/**
 * Whether the app (native) or tab (web) is in the foreground right now. Web
 * reads `document` through a guard: native release builds have none.
 */
export function isAppInForeground(): boolean {
  if (Platform.OS !== 'web') return AppState.currentState === 'active'
  return typeof document === 'undefined' || document.visibilityState !== 'hidden'
}
